<template>
<div class="byhand">

    <h1>Конструктор круизов</h1>

    <div v-if="testappUse" class="byhand--fill-test"><button @click="byhand_fill_test">заполнить круиз тестовыми данными</button></div>

    <div v-if="!dict.towns" class="CruisePage__ifloader"><Loader class="CruisePage__loader" /></div>
    <div v-if="dict.towns">
        <div class="bhform">

            <div class="bhform-row">
                <div class="bhform-row--text">
<ul>                    
<li>Для корректного бронирования, пожалуйста, укажите ссылку на круиз с сайта туроператора.</li>
<li>Если вы бронируете несколько кают, укажите номера совместно бронируемых заявок. </li>
<li>Если необходимо применение дополнительных скидок на круиз-укажите в комментарии и прикрепите соответствующие документы к заявке. </li>
<li>Сообщите иные существенные пожелания и комментарии.</li>
<li>После бронирования заявки у туроператора мы дополнительно согласуем с вами стоимость и фактическую величину агентского вознаграждения с учетом промо прайсов, акций и т.д. - отслеживайте сообщения по заявкам.</li>
</ul>
                </div>
            </div>

            <div class="bhform-row" style="justify-content: center;"><div class="cabins-guests__header" >Данные круиза</div></div>


            <MyMulti
                class="bhform-row" :class="{red:isRed('oper_id')}"
                classinput="bhform-row--input"
                :list="dict.opers" :onlyone="true" :choosed="nov.oper_id" @input="select('oper_id', $event)" placeholder="..."
            >
                <div class="bhform-row--title">Туроператор</div>
            </MyMulti>


            <MyMulti
                class="bhform-row" :class="{red:isRed('stown_id')}"
                classinput="bhform-row--input"
                :list="dict.towns" :onlyone="true" :choosed="nov.stown_id" @input="select('stown_id', $event)" placeholder="..."
            >
                <div class="bhform-row--title">Город отправления</div>
            </MyMulti>

            <div class="bhform-row">
                <div class="bhform-row--title">Дата отправления</div>
                <div class="bhform-row--input">
                    <date-pick 
                        class="custom-datepick bhform-row--input"
                        :class="{red:isRed('date')}"
                        :value="nov.date"
                        @input="select('date', $event)"
                        :format="format"
                        :nextMonthCaption="nextMonthCaption"
                        :prevMonthCaption="prevMonthCaption"
                        :setTimeCaption="setTimeCaption"
                        :weekdays="weekdays"
                        :months="months"
                        :selectableYearRange="2"
                    ></date-pick>
                    <span class="fieldError" v-if="isRed('date')">{{errorField('date')}}</span>
                </div>
            </div>


            <div class="bhform-row">
                <div class="bhform-row--title">Дней</div>
                <div class="bhform-row--input"><select  class="custom-select" :class="{red:isRed('nights')}"
                 :value="nov.nights" @input="select('nights', $event.target.value)"><option v-for="option in nights_options" :value="option.id">{{option.name}}</option></select></div>
            </div>


            <MyMulti 
                class="bhform-row" :class="{red:isRed('ship_id')}"
                classinput="bhform-row--input"
                :list="dict.shipsWnd" :onlyone="true" :choosed="nov.ship_id" @input="select('ship_id', $event)" placeholder="..." 
            >
                <div class="bhform-row--title">Теплоход</div>
            </MyMulti>


            <MyMulti
                class="bhform-row" :class="{red:isRed('btown_id')}"
                classinput="bhform-row--input"
                :list="dict.towns" :onlyone="true" :choosed="nov.btown_id" @input="select('btown_id', $event)" placeholder="..." 
            >
                <div class="bhform-row--title">Город прибытия</div>
            </MyMulti>

            <div class="bhform-row">
                <div class="bhform-row--title bhform-price">Цена</div>
                <div class="bhform-row--input bhform-price--a">
                    <input type="text" 
                        class="custom-input" :class="{red:isRed('price')}"
                        :value="nov.price" @input="select('price', $event.target.value.trim())" 
                    />
                    <span class="fieldError" v-if="isRed('price')">{{errorField('price')}}</span>
                </div>
                <div class="bhform--price-b">
                    <select  class="custom-select" :class="{red:isRed('currency_id')}"
                 :value="nov.currency_id" @input="select('currency_id', $event.target.value)"><option v-for="option in currency_options" :value="option.id">{{option.name}}</option></select>
                </div>
            </div>

            <div class="bhform-row">
                <div class="bhform-row--title">Каюта (желательно)</div>
                <div class="bhform-row--input">
                    <input type="text" 
                        class="custom-input" :class="{red:isRed('cabin_name')}"
                        :value="nov.cabin_name" @input="select('cabin_name', $event.target.value.trim())" 
                    />
                    <span class="fieldError" v-if="isRed('cabin_name')">{{errorField('cabin_name')}}</span>
                </div>
            </div>

            <div class="bhform-row">
                <div class="bhform-row--title">Тип каюты (желательно)</div>
                <div class="bhform-row--input">
                    <input type="text" 
                        class="custom-input" :class="{red:isRed('type_name')}"
                        :value="nov.type_name" @input="select('type_name', $event.target.value.trim())" 
                    />
                    <span class="fieldError" v-if="isRed('type_name')">{{errorField('type_name')}}</span>
                </div>
            </div>

            <div class="bhform-row">
                <div class="bhform-row--title">Палуба (желательно)</div>
                <div class="bhform-row--input">
                    <input type="text" 
                        class="custom-input" :class="{red:isRed('deck_name')}"
                        :value="nov.deck_name" @input="select('deck_name', $event.target.value.trim())" 
                    />
                    <span class="fieldError" v-if="isRed('deck_name')">{{errorField('deck_name')}}</span>
                </div>
            </div>

            <div class="bhform-row">
                <div class="bhform-row--title">Ссылка на круиз (желательно)</div>
                <div class="bhform-row--input">
                    <input type="text" 
                        class="custom-input" :class="{red:isRed('tour_url')}"
                        :value="nov.tour_url" @input="select('tour_url', $event.target.value.trim())" 
                    />
                    <span class="fieldError" v-if="isRed('tour_url')">{{errorField('tour_url')}}</span>
                </div>
            </div>




        </div>

        <div class="cabins-guests__header" style="margin-top: 30px">Выберите размещение</div>

        <SelectOccupation :Cabin="cstore.getCabinCons.Cabin" />


        <div class="cabins-guests__header">Пассажиры</div>
        
        <div class="cabins-guests__content">
            <div class="cabins-guests__section">
                <div class="cabin">
                    <div class="cabin__wrapper">
                        <div class="cabin__header cabin-header">
                            <div class="cabin-header__content">
                                <div class="cabin-header__title">Пассажиры каюты</div>
                            </div>
                        </div>
                        <div class="cabin__content cabin-content">
                            <template v-for="place in cstore.getCabinCons.places">
                                <FillPlace 
                                    class="cabin-content__place" 
                                    :place="place" 
                                    :cabinId="cstore.getCabinCons.id"
                                    :Cabin="cstore.getCabinCons.Cabin" 
                                    :ages="cstore.getCabinCons.ages"
                                    :key="place.pnum" 
                                />
                            </template>
                        </div>
                    </div>

                    <CabinErrors :errors="cabinErrors[cstore.getCabinCons.id]" />

                </div>
            </div>

            <div class="cabins-guests__section">
                <div class="cabin">
                    <div class="cabin__wrapper">
                        <div class="cabin__header cabin-header">
                            <div class="cabin-header__content">
                                <div class="cabin-header__title">Заказчик</div>
                            </div>
                        </div>
                        <div class="cabin__content cabin-content">
                            <FillPlace class="cabin__persons__place" 
                                :place="bookCabins.customerCabinPlace" 
                                :cabinId="bookCabins.customerCabinId" 
                                validationMode="strict" />
                        </div>
                    </div>

                    <CabinErrors :errors="cabinErrors[cuCabin]" />

                </div>

                <div class="cabin" style="grid-column: span 2;">
                    <div class="cabin__wrapper">
                        <div class="cabin__header cabin-header">
                            <div class="cabin-header__content">
                                <div class="cabin-header__title">Комментарии и скидки</div>
                            </div>
                        </div>
                        <div class="cabin__content cabin-content">
                            <div class="cabin-content__comment">
                                <textarea v-model="bookCabins.notes_note" placeholder="Ваш комментарий к заказу"></textarea>
                            </div>
                            <div class="cabin-content__checkbox-options">
                                <MyCheckbox :choosed="bookCabins.notes_attachDoc" @input="bookCabins.notes_attachDoc = $event">
                                    <span>Пенсионная скидка</span>
                                </MyCheckbox>
                                <div v-if="bookCabins.notes_attachDoc">Для подтверждения скидки прикрепите пенсионное удостоверение после сохранения заявки</div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

    

        </div>


        <div class="byhand-submit">
            <div v-if="errors.length" class="error-list byhand-submit--a">
                <div>Обнаружено следующее:</div>
                <div class="error-list--li" v-for="({text}) in errors">{{text}}</div>
            </div>


            <div class="byhand-submit--warn" v-if="nov.ship_id && getShip().is_sea">
                На каждого пассажира необходим свой заграничный паспорт, срок действия которого не менее 6 мес. с даты окончания круиза
            </div>

            <div class="byhand-submit--b">
                <button v-if="!dobook.wait" class="btn btn--blue" @click="bookit">бронировать</button>
                <Loader v-if="dobook.wait" class="byhand-submit--loader" />
            </div>

            <div v-if="dobook.error" class="error-list byhand-submit--c">
                Заявка не создана
                <div class="error-list--li">{{dobook.error}}</div>
            </div>
        </div>
    </div>
</div>
</template>


<style lang="scss" src="./ByHandPage.scss"></style>

<script setup>
import '@/comp/FaseBook/CabinsGuests.scss'

import {testappUse } from 'TESTAPP/testapp.js'    
import {ref, reactive, unref, computed, onMounted} from 'vue'
import { useRouter, useRoute } from 'vue-router/composables'
import {LOCALSTOR_BOOK_KEY, LOCALSTOR_TOURIST_KEY, save_localStorage} from '@/localStor.js'
import {propbyhand, nc_eq, _get, book, random_str} from '@/actions.js'
import MyMulti from '@/comp/MyMulti/MyMulti.vue'
import Loader from '@/comp/Loader/Loader.vue'

import DatePick from 'vue-date-pick'
import 'vue-date-pick/src/vueDatePick.scss'
import { numWord } from '@/util.js'


import useTouristStore from '@/tourist/tourist-store.js'
import useCabinsStore from '@/bookCabins.js'
import {CRUISE_CONSTRUCTOR, AGES_CONSTRUCTOR, uid_func, CABIN_CONSTRUCTOR} from '@/cstore.js'
import useCruiseStore from '@/cstore.js'

import useCruiseOrderCheck from '@/comp/useCruiseOrderCheck.js'

import {beforeBookCheck} from '@/comp/useOrder.js'

import FillPlace from '@/comp/FaseBook/FillPlace.vue'

import CabinErrors from '@/comp/FaseBook/CabinErrors.vue'

import SelectOccupation from '@//comp/FaseList/SelectOccupation.vue'
import MyCheckbox from '@/comp/MyCheckbox/MyCheckbox.vue'



import { create, test, enforce, only, skipWhen, warn, optional, omitWhen } from "vest";
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)

const router = useRouter()

const cstore = useCruiseStore()
const tstore = useTouristStore()
tstore.pers_load_localstor(  LOCALSTOR_TOURIST_KEY )
const bookCabins = useCabinsStore()
const cuCabin = bookCabins.customerCabinId


const dict=ref({})
const nov = ref({
    date: '',
    nights: -1,
    ship_id: '',
    ship_is_sea: null,
    stown_id: '',
    oper_id : '',
    btown_id: '',
    price: '',
    touch: 0,
    tour_url: '',
    cabin_name: '',
    deck_name: '',
    type_name: '',
    currency_id: 1,
})

const getShip = () => {
    let {ship_id} = unref(nov)
    let {ships} = unref(dict)
    let ret = null
    if (ship_id && ships) {
        ret = ships.find( ({id}) => id === ship_id )
    }
    return ret
}


const byhand_fill_test = () => {
    let t = {
        date:"05.05.2026",
        nights: 8,
        ship_id: '182',
        stown_id: '37', 
        oper_id: '216',
        btown_id: '37', 
        price: '23425',

        tour_url: 'https://som.cruise.comp/sdfsdf',
        cabin_name: '333',
        deck_name: 'Верхняя палуба',
        type_name: 'В3С',
        currency_id: 2,

    }
    nov.value = { ...nov.value, ...t}
    nov_touch()
}


const format = 'DD.MM.YYYY'
const nextMonthCaption='Следующий месяц'
const prevMonthCaption='Предыдущий месяц'
const setTimeCaption='Время';
const weekdays = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
const months=[
        'Январь', 'Февраль', 'Март', 'Апрель',
        'Май', 'Июнь', 'Июль', 'Август',
        'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
    ];


const dateGTE = (v, x)=>{
        let vday = dayjs(v, format, true)
        let xday = dayjs(x, format, true)
        let valid = true // если нет лимита, то тест проходит
        if (vday.isValid() && xday.isValid()) {
            valid = vday.isSame( xday, 'day' ) || vday.isAfter( xday, 'day' )
        }
//console.log('dateGTE', v, vday,  x, xday, valid)
        return valid
}
const dateLTE = (v, x)=>{
        let vday = dayjs(v, format, true)
        let xday = dayjs(x, format, true)
        let valid = true // если нет лимита, то тест проходит
        if (vday.isValid() && xday.isValid()) {
            valid = vday.isSame( xday, 'day' ) || vday.isBefore( xday, 'day' )
        }
        return valid
}
//window.dayjs = dayjs

enforce.extend({
    isDMY(v) {
        return dayjs(v, 'DD.MM.YYYY', true).isValid()
    },
    dateGTE,
    dateLTE,
})    


const date_limit=computed(()=>{
    let {date_min, date_max} = unref(dict)
    if (date_min) {
        date_min = dayjs( date_min ).format( format )
        date_max = dayjs( date_max ).format( format )
    }
    return {date_min, date_max}
})

const check_func = (data = {}, currentField) => {
//     date: '',     nights: -1,     ship_id: '',     stown_id: '',     btown_id: '',     price: '',    
    let onar = [currentField]
    if ('ship_id' == currentField) {
        onar = ['ship_id', 'currency_id']
    } else if ('currency_id' == currentField) {
        onar = ['currency_id', 'ship_id']
    }
    only(onar)


    optional(['cabin_name', 'deck_name', 'type_name', 'tour_url' ]);

    test('date', "введите дату в формате DD.MM.YYYY", ()=>{
        enforce(data.date).isDMY();
    });

    test('date', `не ранее ${data.date_min}`, ()=>{
        enforce(data.date).dateGTE( data.date_min );
    });
    test('date', `не позднее ${data.date_max}`, ()=>{
        enforce(data.date).dateLTE( data.date_max );
    });


    test('nights', "проверьте", () => {
        enforce(data.nights).greaterThan(-1)
    })


    test('ship_id', "проверьте", () => {
        enforce(data.ship_id).longerThanOrEquals(1);
    })

    test('stown_id', "проверьте", () => {
        enforce(data.stown_id).longerThanOrEquals(1);
    })

    test('oper_id', "проверьте", () => {
        enforce(data.oper_id).longerThanOrEquals(1);
    })

    test('btown_id', "проверьте", () => {
        enforce(data.btown_id).longerThanOrEquals(1);
    })

    test('price', "введите число", () => {
        enforce(data.price).isNumeric();
    })

    test('price', "больше 100", () => {
        enforce(data.price).greaterThan(100);
    })

    test('currency_id', "введите цену в валюте", () => {
         !data.ship_is_sea || data.currency_id > 1
    })

    omitWhen( !data.ship_is_sea , () => {
        test('currency_id', "введите цену в валюте", () => {
            enforce(data.currency_id).greaterThan(1);
        })
    } )


    omitWhen( "" === data.tour_url , () => {
        test('tour_url', "ссылка должна начинаться с http(s)://", () => {
            enforce(data.tour_url).matches(/^https?\:\/\/./i);
        })
    } )
}

const nov_vest = create( check_func )

const isRed =  (key) => { // не проверенные светится не будут
  let rec = unref(nov_check).tests 

  return _get( rec, [key, 'errorCount'] ) > 0 ? true : false
}

const errorField =  (key) => { // не проверенные светится не будут
  let rec = unref(nov_check).tests 

  return _get( rec, [key, 'errors', 0] )
}


const nov_check = computed(() => {
    let res = nov_vest.get()
//console.log('nov_check', res)
    let { errorCount, warnCount, testCount, tests } = res
    let isValid = res.isValid()
    return { errorCount, warnCount, testCount, tests, isValid, nov: unref(nov) }
})

const errors = computed( () => {
    const byhand_err = []
    let {isValid, testCount, errorCount} = unref(nov_check)
    if (!isValid) {
        let text = testCount ? 'Не все поля заполнены верно' : 'Необходимо заполнить поля: Туроператор, Город отправления, Дата отправления'
        text = `Данные круиза: ${text}`
        byhand_err.push({text,type: 'byhand'})
    }
    const {errs} = beforeBookCheck( cstore, tstore, bookCabins )
    let ret = [ ...byhand_err, ...errs]
    return ret
} )



const dobook = reactive({
    wait: false,
    error: '',
    bookData: {}
})

const nov_touch = () => {
    nov.value = { ...nov.value, touch: Date.now() }
    let vals = { ...unref(nov), ...unref(date_limit) }
    nov_vest( vals , null )
}

const bookit = () => {
    nov_touch()
    if (unref(errors).length) {
        return
    }
    if (dobook.wait) {
        return
    }
    dobook.error=''
    const {travelers} = beforeBookCheck( cstore, tstore, bookCabins )
    let bookData = { ...travelers}
    let {
        date, nights, ship_id, stown_id:swtown_id, oper_id, btown_id:bwtown_id, price, 
        cabin_name, deck_name, type_name, tour_url, currency_id,
    } = unref( nov )
    bookData.key = 'bh'+random_str()
    bookData.offer = {
        date: dayjs(date, format, true).format('YYYY-MM-DD'),
        nights,
        ship_id,
        swtown_id,
        oper_id,
        bwtown_id,
        price,
        cabin_name, deck_name, type_name, tour_url, currency_id,
    }
    dobook.bookData = bookData
    book( bookData ).then( 
        resolve => proc_book( {resolve } ),
        reject =>  proc_book( {reject} )
    )
}
const proc_book = ({resolve, reject}) => {
    dobook.wait = false
    if (reject) {
        dobook.error = reject.toString()
    } else { // на серве
        // calc_prices тут не возвращается пока, но надеюсь будет
        let { message, claim_id, claim_num  } = resolve
        let { bookData } = dobook
        const { _ : sid } = nc_eq()
        let status = {
            ok: true,
            ts: '',
        }

        const locob = { sid, message, claim_id, claim_num, bookData, status }
        bookCabins.clean()
        tstore.clean()
        save_localStorage( LOCALSTOR_BOOK_KEY, locob )
        router.push({name: 'BookOk', query: {sid} })
    }
}

const select = (key, val) => {
  nov.value = { ...nov.value, [key]:val }
  if ('ship_id' === key) {
    let ship=dict.value.shipsWnd.find( ob => ob.id === val )
    nov.value.ship_is_sea = ship ? ship.is_sea : null
//oconsole.log('selec ship_id', nov.value.ship_id, nov.value.ship_is_sea)    
  }
  let vals = { ...unref(nov), ...unref(date_limit) }
  nov_vest( vals , key )
}




const nights_options=computed(()=>{
    let {nights_max, nights_min} = unref(dict)
    let ret
    if (!nights_max) {
        ret = []
    } else { 
        let a = unref(dict).nights_min
        let b = unref(dict).nights_max
        let l = b-a

        ret = Array.from({length:l}).map( 
            ( xxx, ind ) => { 
                return {id: a+ind} 
            }
        ).map(
            ({id}) => {
                return {
                    id, 
                    name: `${numWord(id+1)}`  
                }
            }
        )

        ret.unshift({id: -1, name: 'не выбрано'})
    }
    return ret
})

const currency_options = [
    {id: 1, name: 'рублей'},
    {id: 2, name: 'долларов'},
    {id: 3, name: 'евро'},
]

const initCabin = () => {
    const cruiseIdFull = CRUISE_CONSTRUCTOR
    const ages = AGES_CONSTRUCTOR
    const key = uid_func('cons')
    const cabinId = CABIN_CONSTRUCTOR
    const tstore_sids_only = tstore.pers.map( p => p.sid )
// roomsMap, tstore_sids
    bookCabins.initBookBox( {cruiseIdFull, ages, tstore_sids_only, key, roomsMap: null , tstore_sids: null,    }  )
    if (!bookCabins.isBooked(cabinId)) {
        bookCabins.initBookBoxCabin( {cabinId, acc: {main: 1, additional: 3}})
        bookCabins.bookUnbook( { cabinId } ) 
    }
}


const cabinErrors = computed(() => {
    const {errsByCabin} = beforeBookCheck( cstore, tstore, bookCabins  )
    return errsByCabin
})

const occupation = bookCabins.getOccupation( CABIN_CONSTRUCTOR )


propbyhand({}).then( dictin => {
    dict.value=dictin
    dict.value.shipsWnd = dict.value.ships.map( ob => {
        let is_sea = ob.is_sea
        let name1 = `${ob.name} ${is_sea ? ' [морской]' : ''}`
        return { ...ob, name: name1, is_sea}
    } )
    return true
} )

initCabin()

</script>
